/**
 * Whether a customer sees the REAL GAIN marketplace publishing sections in the offer editors
 * (prompt tool, knowledge base, agentic workflow, agent toolset). See
 * docs/marketplace-publishing-toggle.md.
 *
 * Off unless `Customer.configuration.marketplacePublishing` is `true` — set by the customer in
 * the company profile. It hides, it does not protect: the offer data and the marketplace routes
 * are untouched, and an offer already in review or live stays there.
 */

/** The editor sections that only matter for publishing in the marketplace. */
export const MARKETPLACE_MENU_KEYS = ['offerStatus', 'details', 'billing'];

export const marketplacePublishingEnabled = (customer: any): boolean =>
    customer?.configuration?.marketplacePublishing === true;

/** The editor menu without the marketplace sections, unless the customer switched them on. */
export const withMarketplaceMenuItems = <T extends { key: string }>(items: T[], customer: any): T[] =>
    marketplacePublishingEnabled(customer)
        ? items
        : items.filter((item) => !MARKETPLACE_MENU_KEYS.includes(item.key));
